module.exports = __webpack_public_path__ + "img/malha-fina.70705b9a.png";